"use client"

import { LocalizationProvider } from "@bullseye/components"

export default function Layout({ children }) {
  return <LocalizationProvider>{children}</LocalizationProvider>
}
